<template>
    <div class="conference-room h-100 has-text-centered mt-5">
        <div class="is-flex is-justify-content-center has-text-centered">
            <div class="column is-6">
                <article class="box-inicio">
                    <div class="article-top-right has-background-primary p-4">
                        <img src="@/assets/images/user-video.png" width="80" />
                    </div>
                    <div class="article-content-right pt-4">
                        <p class="title is-4 has-text-primary">
                            Esperando que este libre un agente ...
                        </p>
                        <p class="subtitle is-6 mt-2 has-text-greyText">
                            Esta en cola esperando que tengamos un agente libre
                            para poder atenderle, en cuanto este disponible le
                            redirigiremos a la sala.
                        </p>
                        <p class="subtitle is-6 mt-2 has-text-greyText">
                            Por favor, no recargue la página o perderá su puesto
                            en la cola y volverá al final.
                        </p>
                    </div>
                </article>
                <div class="columns mt-3">
                    <div class="column is-12">
                        <div class="field">
                            <label class="label">Cédula</label>
                            <p>{{ userId }}</p>
                        </div>
                        <div class="field">
                            <label class="label">Trámite</label>
                            <Loading v-if="isLoading" />
                            <p v-else>{{ skill }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import * as SignalR from "@microsoft/signalr";
import Loading from "@/components/Loading.vue";

export default {
    name: "online-user",
    components: {
        Loading,
    },
    data() {
        return {
            isLoading: true,
            processId: null,

            id: null,
            userId: null,
            environment: null,
            skill: null,

            signalRSocket: null,
            bioData: null,
        };
    },
    async beforeDestroy() {
        await RepositoryFactory.onlineUser.notifyLeaveQueue({
            userId: this.userId,
            processId: this.processId,
        });

        let socket = this.signalRSocket;
        this.signalRSocket = null;
        await socket.stop();
    },
    async mounted() {
        this.userId = this.$route.query.userId;
        this.environment = this.$route.query.environment;
        this.processId = this.$route.query.processId;

        await this.signalRInitialize();

        // Before join on queue, add join event listener
        this.signalRSocket.on("RoomOpened", this.roomOpened);

        this.isLoading = true;

        let response = await RepositoryFactory.onlineUser.getProcess({
            id: this.processId,
        });

        let process = response.data;
        if (process !== "" && process !== null && process.roomId !== null) {
            window.console.log(process);
            await this.roomOpened({
                userId: this.userId,
                roomId: process.roomId,
            });
            return;
        }

        let payload = {
            userId: this.userId,
            environment: this.environment,
            processId: this.processId,
            connectionId: this.signalRSocket.connectionId,
        };
        response = await RepositoryFactory.onlineUser.startProcess(payload);
        this.bioData = response.data;
        this.skill = this.bioData.skill;
        // And then join the queue
        await this.signalRSocket.invoke("UserJoin", this.userId);

        this.isLoading = false;
    },
    methods: {
        async signalRInitialize() {
            try {
                const socket = new SignalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_ONLINE_HUB)
                    .withAutomaticReconnect()
                    .build();

                socket.connection.onclose = async (error) => {
                    if (error !== undefined) this.$log(error);

                    this.$log("Reconnecting...");
                    this.signalRSocket = false;
                    await this.signalRInitialize();
                };

                await socket.start();

                this.signalRSocket = socket;
            } catch (err) {
                this.$log("Error, reconnecting...");

                setTimeout(() => {
                    this.signalRInitialize();
                }, 1000);
            }
        },
        async roomOpened(payload) {
            if (payload.userId === this.userId) {
                await RepositoryFactory.onlineUser.notifyLeaveQueue({
                    userId: this.userId,
                    processId: this.processId,
                });

                this.$router.push({
                    name: "room",
                    params: {
                        roomId: payload.roomId,
                    },
                    query: {
                        cedula: this.userId,
                        environment: this.environment,
                        processId: this.processId,
                    },
                });
            }
        },
    },
};
</script>
